module.exports = __webpack_public_path__ + "media/images/plant-7ab3c2f8b640f3a86388d79caa482180.png";